import React from "react";
import styled from "styled-components";

const SnowFlake = styled.div`
  /* position: absolute;
  display: flex; 
  z-index: 1; */

`;
const SnowEff: React.FC = () => {
  return (
    <SnowFlake>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>❤️</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>✨</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>🎹</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>🎻</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>🎸</div>
      <div className={"snowflake"}>🎺</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>❄</div>
      <div className={"snowflake"}>🎷</div>
      <div className={"snowflake"}>❄</div>
    </SnowFlake>
  );
};

export default SnowEff;
